import { Component } from '@angular/core';
import { Field } from '@intersystems/isc-form';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'app-isc-form-select-wrapper',
  templateUrl: './isc-form-select-wrapper.component.html',
  styleUrls: ['./isc-form-select-wrapper.component.scss'],
})
export class IscFormSelectWrapperComponent extends FieldWrapper {
  field: Field;
}
